export default Object.freeze({
  DISCARD: 'Discard',
  COLLECTED: 'Collected',
  WAIT_FOR_RETURN: 'WaitForReturn',
  WAIT_FOR_COLLECT: 'WaitForCollect',
  GENESIS_CREDITS_ADDED: 'GenesisCreditsAdded',
  GENESIS_PROCESSING_ORDER: 'GenesisProcessingOrder',
  GENESIS_SENDING_TO_THIRD_PARTIES_API: 'GenesisSendingToThirdPartiesApi',
  GENESIS_WAITING_FOR_REGISTRATION: 'GenesisWaitingForRegistration',
  TO_BE_PAID: 'ToBePaid',
});
